import { E as EmblaCarousel } from './embla-carousel.esm-DpJzJcqm.js';
import { W as WheelGesturesPlugin } from './embla-carousel-wheel-gestures.esm-BSvTFWB9.js';

class CollectionNavigation extends HTMLElement {
  #viewport = this.querySelector('.embla__viewport');
  /** @type {import('embla-carousel').EmblaCarouselType} */
  #embla;
  #draggable = true;

  connectedCallback() {
    this.#initCarousel();
  }

  disconnectedCallback() {
    this.#embla?.off('reinit', this.#updateDraggable);
    this.#embla?.destroy();
  }

  /**
   * Initialize the horizontal sub-collection navigation strip. The text and
   * visual variants only differ in slide width (driven by CSS), so the carousel
   * config is shared. Mouse-wheel scrolling releases at the edges.
   */
  #initCarousel() {
    if (!this.#viewport) return;

    this.#embla = EmblaCarousel(this.#viewport, { align: 'start', skipSnaps: true }, [
      WheelGesturesPlugin(),
    ]);

    this.#embla.on('reinit', this.#updateDraggable);
    this.#updateDraggable();
  }

  /**
   * Disable dragging when every item already fits, so the strip doesn't slide
   * with too few slides. Re-checked on each reInit (e.g. resize, breakpoint).
   */
  #updateDraggable = () => {
    const canScroll = this.#embla.canGoToPrev() || this.#embla.canGoToNext();
    if (canScroll === this.#draggable) return;

    this.#draggable = canScroll;
    this.#embla.reInit({ draggable: canScroll });
  };
}

customElements.define('collection-navigation', CollectionNavigation);
